import { Animation, AnimationConfig } from './types';

export class ZaraAnimation2D implements Animation {
  private ctx: CanvasRenderingContext2D;
  private canvas: HTMLCanvasElement;

  constructor({ canvas }: AnimationConfig) {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Failed to get 2D context');
    }

    this.ctx = ctx;
    this.canvas = canvas;
  }

  update(audioData?: Uint8Array): void {
    if (!audioData) {
      console.error('No audio data or AI speaking');
      return;
    }

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';

    const binWidth = this.canvas.width / audioData.length;

    for (let i = 0; i < audioData.length; i++) {
      const value = audioData[i] / 255;
      const binHeight = value * this.canvas.height;

      this.ctx.fillRect(
        i * binWidth,
        0.5 * (this.canvas.height - binHeight),
        binWidth,
        binHeight,
      );
    }
  }

  cleanup(): void {}
}
